export enum SkillTypeEnum {
    Behaviorism,
    Technical,
    GeneralTechnical,
    Certificate
}